import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "../../assets/css/contact.css";

const Contact = () => {
	return (
		<>
			{/* Header starts here */}
			<Header />
			{/* Header ends here */}
			{/* contact form starts here */}
			<section className="contact-form">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<div className="contact-form-info-wrapper">
								<div className="heading-wrapper">
									<h4>Location</h4>
								</div>
								<div className="info">
									<h5>STORE</h5>
									<p>
										68 Atlantic Ave St, Brooklyn, NY 90002, USA (+005) 5896 72
										78 79 support@farmart.com
									</p>
								</div>
								<div className="info">
									<h5>WAREHOUSE</h5>
									<p>
										172 Richmond Hill Ave St, Stamford, NY 90002, USA (+005)
										5896 03 04 05
									</p>
								</div>
								<div className="social-icon-wrapper">
									<div className="heading-wrapper">
										<h5>Social</h5>
									</div>
									<ul>
										<li>
											<a href="#">
												<i className="fa-brands fa-facebook-f"></i>
											</a>
										</li>
										<li>
											<a href="#">
												<i className="fa-brands fa-twitter"></i>
											</a>
										</li>
										<li>
											<a href="#">
												<i className="fa-brands fa-vimeo-v"></i>
											</a>
										</li>
										<li>
											<a href="#">
												<i className="fa-brands fa-google-plus-g"></i>
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="col-lg-8 align-self-center">
							<div className="contact-heading-wrapper">
								<h5>Contact us</h5>
								<p>
									Required fields are marked <span>*</span>
								</p>
							</div>
							<div className="contact-form-wrapper">
								<form action="">
									<div className="form-group">
										<input
											type="text"
											className="form-control"
											placeholder="Subject (Optional)"
										/>
									</div>
									<div className="form-group">
										<textarea
											name=""
											placeholder="Write your message here"
											id=""
											cols="30"
											rows="5"
											className="form-control"
										></textarea>
									</div>
									<div className="form-group row">
										<div className="col-lg-6">
											<input
												type="text"
												className="form-control"
												placeholder="name"
											/>
										</div>
										<div className="col-lg-6">
											{" "}
											<input
												type="text"
												className="form-control"
												placeholder="Your Email *"
											/>
										</div>
									</div>
									<div className="form-group">
										<button className="btn" type="button">
											Send Message
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* contact form ends here */}
			{/* map sec starts here */}
			<section className="map-sec">
				<div className="container-fluid px-0">
					<div className="row">
						<div className="col-lg-12">
							<div className="mapouter">
								<div className="gmap_canvas">
									<iframe
										width="100%"
										height="500"
										id="gmap_canvas"
										src="https://maps.google.com/maps?q=henry%20county%20&t=&z=13&ie=UTF8&iwloc=&output=embed"
										frameborder="0"
										scrolling="no"
										marginheight="0"
										marginwidth="0"
									></iframe>
									<a href="https://123movies-a.com"></a>
									<br />
									<a href="https://www.embedgooglemap.net"></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* map sec ends here */}
			{/* Footer starts here */}
			<Footer />
			{/* Footer ends here */}
		</>
	);
};

export default Contact;
